import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@ui/icon/icon.component';
import { Router } from '@angular/router';
import { AuthService } from '@auth/services/auth.service';

@Component({
  selector: 'app-user-menu',
  standalone: true,
  imports: [CommonModule, IconComponent],
  template: `
    <div
      *ngIf="isOpen"
      class="absolute right-0 top-full mt-2 w-48 bg-white rounded-lg shadow-lg border border-slate-200 py-1 z-50"
    >
      <div class="px-4 py-2 border-b border-slate-200">
        <div class="text-sm font-medium">{{ currentUser()?.name ?? '' }}</div>
        <div class="text-xs text-slate-500">{{ currentUser()?.email ?? '' }}</div>
      </div>
      <button
        class="w-full px-4 py-2 text-left text-sm hover:bg-slate-50 flex items-center gap-2"
        (click)="goToSettings()"
      >
        <ui-icon name="settings" [size]="'base'"></ui-icon>
        <span>Instellingen</span>
      </button>
      <button
        class="w-full px-4 py-2 text-left text-sm hover:bg-slate-50 flex items-center gap-2"
        (click)="logout()"
      >
        <ui-icon name="logout" [size]="'base'"></ui-icon>
        <span>Uitloggen</span>
      </button>
    </div>
  `
})
export class UserMenuComponent implements OnInit {
  @Input() isOpen = false;
  @Output() isOpenChange = new EventEmitter<boolean>();
  authService = inject(AuthService);
  router = inject(Router);

  currentUser = this.authService.currentUser;

  constructor(

  ) {}

  ngOnInit() {

  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  goToSettings(): void {
    this.isOpen = false;
    this.isOpenChange.emit(false);
    this.router.navigate(['/user-settings']);
  }
}
